module.exports = __webpack_public_path__ + "img/20260411_ICLR.f6e081ad.png";